// extracted by mini-css-extract-plugin
module.exports = {"scrollDistance":"ScrollDistanceContainer--scroll-distance--1JHn2","hidden":"ScrollDistanceContainer--hidden--2_HjW","debug":"ScrollDistanceContainer--debug--1TnqJ"};